const storeLocalesMap = {
    default: ['es'],
    b2b: ['en', 'es'],
    storeview_b: ['en']
}

const storeCode = process.env.NEXT_PUBLIC_STORE_CODE || 'default'

module.exports = {
    i18n: {
        defaultLocale: 'es',
        locales: storeLocalesMap[storeCode]
    },
    nsSeparator: '||',
    keySeparator: '|'
}
